
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.12347',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.12347",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.469",
  "data-fetching-client": "static-1.9692",
  "foundations-components": "static-1.7985",
  "foundations-components-legacy": "static-1.1010",
  "foundations-theming": "static-1.4445",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.82",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8039",
  "hub-http-shared-msw-handlers": "static-1.10024",
  "hubspot-dlb": "static-2.1854",
  "hubspot-url-utils": "static-1.4132",
  "HubStyleTokens": "static-2.11498",
  "I18n": "static-7.1631",
  "jasmine-runner": "static-1.6489",
  "marketplace-storefront-base": "static-1.12408",
  "quartz": "static-1.7063",
  "react-dlb": "static-1.79",
  "react-rhumb": "static-1.16697",
  "reactive-variable-buffer-atom": "static-1.2884",
  "reporting-testing-lib": "static-1.9600",
  "settings-ui-lib": "static-1.12545",
  "SharedI18nStrings": "static-1.182",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7184",
  "ui-addon-i18n": "static-1.11174",
  "ui-addon-react-router-dom": "static-1.9567",
  "unified-auth": "static-1.522",
  "unified-auth-core-lib": "static-1.804",
  "usage-tracker": "static-1.7373",
  "usage-tracker-core": "static-1.7223",
  "customer-data-property-utils": "static-1.8116",
  "hub-http": "static-1.6247",
  "integrations-lib": "static-1.16236",
  "marketplace-ui-common": "static-1.19827",
  "property-management-iframe": "static-1.13244",
  "quartz-config": "static-1.841",
  "quartz-core": "static-1.6282",
  "quartz-routing": "static-1.493",
  "quick-fetch": "static-1.3935",
  "react": "static-7.186",
  "rpc-client-utils": "static-1.4677",
  "ts-schema": "static-1.4099",
  "ui-universal-auth": "static-1.9008",
  "UIComponents": "static-3.8444",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.79",
  "metrics-js": "static-1.9637",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3418",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3340",
  "quartz-webpack": "static-1.3287",
  "bend-plugin-quartz-routing": "static-1.141",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4254",
  "floating-ui": "static-1.56",
  "foundations-assets": "static-1.4893",
  "foundations-theming-specialty": "static-1.2161",
  "framer-motion": "static-1.72",
  "hs-story-utils": "static-1.9449",
  "react-aria": "static-1.66",
  "react-create-root-preference": "static-1.29",
  "react-select-plus": "static-1.105",
  "react-utils": "static-2.5363",
  "react-virtualized": "static-2.99",
  "StyleGuideUI": "static-3.487",
  "tanstack-table": "static-1.55",
  "trellis-assets": "static-1.2025",
  "ui-fonts": "static-1.760",
  "ui-images": "static-2.1160",
  "bend-plugin-foundations-theming": "static-1.2928",
  "foundations-theming-base": "static-1.3430",
  "stylex": "static-1.33",
  "HeadJS": "static-2.764",
  "hs-test-utils-bend-plugin": "static-1.3150",
  "msw": "static-1.39",
  "testing-library": "static-1.152",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.221",
  "moment-timezone": "static-5.83",
  "jasmine": "static-4.4352",
  "ai-components-ui-library": "static-1.9035",
  "ai-rendering-library": "static-1.10258",
  "chirp-fetch": "static-1.1913",
  "connections-embed-lib": "static-1.1034",
  "copilot-toolkit": "static-1.11198",
  "feedback-loader": "static-1.29340",
  "laboratory-lib": "static-3.7181",
  "marketplace-embed": "static-1.22158",
  "marketplace-ui-details": "static-1.9723",
  "marketplace-ui-reviews": "static-1.19783",
  "marketplace-ui-tracking": "static-1.13998",
  "sanitize-text": "static-1.8168",
  "ui-addon-video-player": "static-1.8728",
  "usage-tracker-multi": "static-1.5787",
  "usage-tracker-session-replay": "static-1.5059",
  "wootric-nps": "static-1.6999",
  "quartz-head": "static-1.728",
  "web-vitals": "static-1.6",
  "apollo-link-hub-http": "static-2.4677",
  "immer": "static-1.33",
  "immerable": "static-1.4179",
  "highcharts": "static-8.104",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2500",
  "reporting-data": "static-1.67667",
  "cssUtils": "static-1.798",
  "flux-actions": "static-1.341",
  "HubStyle": "static-2.11805",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10233",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10391",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7363",
  "icons": "static-2.650",
  "marketplace-ui-apps-core": "static-1.18360",
  "storybook-react": "static-1.33",
  "trellis-story-utils": "static-1.4540",
  "foundations-components-test-utils": "static-1.5468",
  "quartz-i18n": "static-1.738",
  "react-input-autosize": "static-2.17",
  "google-sheets-integration-lib": "static-1.313",
  "microsoft-drive-integration-lib": "static-1.444",
  "slack-ui-library": "static-1.10417",
  "fsm": "static-1.3757",
  "customer-data-objects": "static-1.7698",
  "property-translator": "static-1.5424",
  "hs-locale-management": "static-1.99",
  "frontend-preferences-client": "static-1.7952",
  "hs-promise-utils": "static-1.5616",
  "hubspot-apollo-client": "static-1.4904",
  "integrations-error-boundary-lib": "static-1.13651",
  "integrations-tracking-lib": "static-1.5627",
  "native-integrations-shared-strings": "static-1.7807",
  "reselect": "static-2.16",
  "sanitize": "static-1.4501",
  "superstore": "static-1.4786",
  "ui-shepherd-react": "static-3.10195",
  "ai-settings-ui-library": "static-1.7923",
  "hub-http-janus": "static-1.838",
  "hubspotter-http": "static-1.4670",
  "immutable-less": "static-1.4678",
  "marketplace-ui-client-types": "static-1.17234",
  "nav-meta": "static-1.29747",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10272",
  "ui-addon-upgrades": "static-9.18034",
  "inbound-db-properties-service-client": "static-1.3865",
  "property-management-common": "static-1.5532",
  "ui-addon-iframeable": "static-1.9085",
  "dispatcher": "static-1.137",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.538",
  "module-federation": "static-1.23",
  "quartz-auth": "static-1.738",
  "quartz-test": "static-1.738",
  "quartz-tracking": "static-1.442",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.87",
  "bender-build-tools": "static-1.3215",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.21413",
  "ContentUtils": "static-1.68441",
  "customer-data-objects-ui-components": "static-1.13054",
  "sassPrefix": "static-1.156",
  "breeze-onboarding-components": "static-1.75",
  "avatar-components": "static-1.2523",
  "customer-data-filters-ui": "static-1.39891",
  "customer-data-reference-ui-components": "static-1.13191",
  "embedded-academy-lib": "static-1.14429",
  "ExportDialog": "static-6.10409",
  "highlight.js": "static-1.79",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.41377",
  "reporting-snowflake": "static-1.56285",
  "reporting-ui-components": "static-2.64938",
  "reporting-visualizations": "static-1.59743",
  "ui-addon-teams": "static-1.21590",
  "magpie-lib": "static-1.5568",
  "navigation-components": "static-1.18110",
  "magpie-types": "static-1.5028",
  "simple-logging-lib": "static-1.3076",
  "ai-studio-lib": "static-1.11690",
  "app-governance-lib": "static-1.1615",
  "developer-experience-shared-components": "static-1.10536",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.8024",
  "ui-product-approvals": "static-1.28214",
  "ui-tool-access": "static-1.10172",
  "usage-based-billing-components-lib": "static-1.9018",
  "usage-tracker-anonymous": "static-1.5790",
  "usage-tracker-public": "static-1.7184",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3605",
  "persist-promise": "static-1.3724",
  "reference-resolvers": "static-1.8196",
  "ui-extensibility-client-types": "static-1.3949",
  "hubspot-apollo-cache": "static-1.363",
  "universal-page-editor-lib": "static-1.3039",
  "final-form": "static-1.70",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.2852",
  "merchandise-lib": "static-1.264",
  "atom": "static-1.5098",
  "purchase-motions-components": "static-1.5965",
  "salesImages": "static-1.525",
  "batch-promise": "static-1.1567",
  "crm-component-utils": "static-1.39147",
  "crm-properties-common-lib": "static-1.5910",
  "customer-data-properties": "static-1.51657",
  "framework-data-schema-resolvers": "static-1.6910",
  "property-value-citations": "static-1.2271",
  "reference-resolvers-lite": "static-1.8120",
  "ui-business-units-lib": "static-1.9080",
  "navigation-messaging": "static-1.7437",
  "hubspotter-http-shared-msw-handlers": "static-1.10022",
  "cms-field-types": "static-1.4837",
  "content-icons-ui": "static-1.2233",
  "customer-data-ui-utilities": "static-1.9851",
  "events-data-lib": "static-1.249",
  "conversations-skeleton-state": "static-1.7273",
  "crm-message-bus": "static-1.43040",
  "customer-data-filters-ui-msw-helpers": "static-1.22326",
  "FormUrlGenerator": "static-2.4744",
  "framework-builder-read-service-client": "static-1.4024",
  "framework-data-schema-quick-fetch": "static-1.6815",
  "multi-account-reference-resolvers": "static-1.1005",
  "onboarding-tours": "static-1.16660",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13755",
  "academy-common-lib": "static-1.13889",
  "content-assistance-lib": "static-1.7789",
  "dashboard-lib": "static-1.81633",
  "file-manager-components": "static-1.23690",
  "getting-started-shared-tasks": "static-1.18521",
  "hubspot-prosemirror": "static-1.18303",
  "hubspot-prosemirror-plugins": "static-1.18295",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19875",
  "share-with-third-party-component-lib": "static-1.8727",
  "ui-addon-draggable": "static-3.4788",
  "ui-asset-management-lib": "static-1.11070",
  "user-context": "static-1.5130",
  "growth-payments-core": "static-1.25451",
  "reporting-plugins": "static-1.10365",
  "reporting-reports": "static-1.67345",
  "idb-keyval": "static-1.44",
  "reactive-lib": "static-1.748",
  "nest": "static-1.254",
  "codemirror": "static-5.95",
  "react-codemirror": "static-1.10651",
  "framework-listing-lib": "static-2.28779",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.30775",
  "apps-service-types": "static-1.3905",
  "oauth-service-types": "static-1.4276",
  "ui-product-approvals-common": "static-1.109",
  "onboarding-scopes": "static-1.6486",
  "onboarding-tours-client": "static-1.4874",
  "platform-infra-nav-components": "static-1.7690",
  "subscription-experience-data-types": "static-1.14969",
  "crm-record-cards-service-types": "static-1.3615",
  "location-customization-utils-lib": "static-1.9337",
  "redux-thunk": "static-2.43",
  "purchase-motions-api": "static-1.5968",
  "signup-constants": "static-1.18889",
  "signup-ui-url-generator": "static-2.8078",
  "card-properties-lib": "static-1.44262",
  "commerce-subscription-lib": "static-1.37193",
  "crm-actions": "static-1.6352",
  "crm-cards-sdk": "static-1.43664",
  "customer-data-properties-shared-msw-handlers": "static-1.9351",
  "customer-data-tracking": "static-1.6915",
  "hs-resources": "static-1.179",
  "pulse": "static-1.602",
  "calling-global-api": "static-1.64600",
  "calling-internal-common": "static-1.31327",
  "calling-lifecycle-internal": "static-1.65982",
  "calling-lifecycle-messages": "static-1.58276",
  "commerce-products-lib": "static-1.9658",
  "conditional-properties-service-client": "static-1.3816",
  "crm-links": "static-1.6320",
  "external-options-client-types": "static-1.4178",
  "google-libphonenumber": "static-1.38",
  "inbounddb-objects-service-types": "static-1.4242",
  "meetings-icalendar-utils-lib": "static-1.657",
  "multi-currency-client-types": "static-1.3710",
  "object-builder-ui-client": "static-1.48828",
  "pipeline-validation-client-types": "static-1.3984",
  "smart-property-lib": "static-1.7213",
  "tiered-pricing": "static-1.1272",
  "zustand": "static-1.74",
  "ui-addon-form-validation": "static-1.11015",
  "crm-pipelines-api-client-types": "static-1.4158",
  "fdsr-migration-layer": "static-1.29",
  "react-dnd-compat": "static-1.4640",
  "react-immutable-render-mixin": "static-1.9",
  "restore-request-side-panel-lib": "static-1.955",
  "growth-data-modal": "static-1.5466",
  "growth-onboarding-confetti": "static-1.3092",
  "growth-onboarding-next-action-utils": "static-1.1992",
  "onboarding-tours-utils": "static-1.726",
  "ui-shepherd-tracker": "static-1.7576",
  "academy-service-client": "static-1.3707",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.39189",
  "FileManagerLib": "static-1.39330",
  "video-embed": "static-1.35852",
  "ui-coaching-tips": "static-1.28631",
  "redux-actions": "static-3.7",
  "video-components-external": "static-1.11360",
  "video-data-lib": "static-1.35018",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8497",
  "payment-link-components": "static-1.23612",
  "ui-addon-emoji-picker": "static-1.9913",
  "EmailSignatureEditor": "static-1.24426",
  "viral-links-lib": "static-1.7091",
  "data-token-picker": "static-1.16449",
  "react-flip-move": "static-1.70",
  "nested-table": "static-1.251",
  "timezone-utils": "static-2.5270",
  "seat-types-lib": "static-1.69",
  "getting-started-shared-tasks-store": "static-1.17639",
  "ui-addon-opt": "static-4.8389",
  "campaign-roi-lib": "static-1.9190",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "customer-data-associations": "static-1.7351",
  "customer-data-views-management": "static-1.25516",
  "framework-data-table": "static-2.11972",
  "marketing-platform-lib": "static-1.6883",
  "nudge-client-utils": "static-1.2639",
  "nudge-custom-ui-functions": "static-1.1062",
  "app-users-service-client": "static-1.5623",
  "app-users-service-types": "static-1.5031",
  "mini-checkout-client": "static-1.26868",
  "onboarding-utils": "static-1.5379",
  "permissions-shared-i18n-strings-fe": "static-1.2046",
  "ui-coaching-tips-shared-config": "static-1.28616",
  "edison-service-client-types": "static-1.414",
  "crm_data": "static-4.92043",
  "customer-data-sidebar": "static-2.46089",
  "enrichment-properties-lib": "static-1.16331",
  "ui-addon-draggable-compat": "static-2.4282",
  "commerce-billing-lib": "static-1.19158",
  "commerce-shared-components-lib": "static-1.18609",
  "commerce-tools-ui-lib": "static-1.10445",
  "crm-fe-perf": "static-1.22929",
  "bend-plugin-pulse": "static-1.105",
  "directed-graph": "static-1.960",
  "event-emitter": "static-1.973",
  "fast-json-patch": "static-1.63",
  "calling-error-reporting": "static-1.31334",
  "shared-worker-versioning": "static-1.11062",
  "calling-usage-tracker": "static-1.6566",
  "voice-sms-access-library": "static-1.1084",
  "commerce-permissions": "static-1.795",
  "products-iframe-lib": "static-1.8007",
  "products-ui-components-shared-msw-handlers": "static-1.10406",
  "data-agent-kit": "static-1.233",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10107",
  "policy-lib": "static-1.6802",
  "react-tinymce": "static-1.55315",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10170",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54441",
  "tinymce-plugins": "static-1.57555",
  "tinymce-themes": "static-1.56411",
  "onboarding-data-sync-lib": "static-1.1995",
  "growth-onboarding-next-action-components": "static-1.2020",
  "user-context-client": "static-1.4637",
  "audio-components": "static-1.5952",
  "cropperjs": "static-1.10",
  "FileManagerImages": "static-1.36841",
  "urlinator": "static-1.4562",
  "video-components": "static-1.13363",
  "outpost": "static-1.4204",
  "growth-onboarding-feedback-components": "static-1.6605",
  "content-media-composition-data-lib": "static-1.12406",
  "content-media-compositions": "static-2.16413",
  "media-bridge-lib": "static-1.18968",
  "commerce-tours-lib": "static-1.6148",
  "growth-onboarding-reliability": "static-1.5107",
  "sales-checkout-service-client": "static-1.3667",
  "draft-convert": "static-2.73",
  "draft-extend": "static-3.75",
  "draft-js": "static-5.78",
  "draft-plugins": "static-2.21718",
  "sales-email-signature-service-client": "static-1.3869",
  "ts-utils-lib": "static-1.197",
  "breeze-engine-lib": "static-1.731",
  "crm-export-dialog": "static-1.6314",
  "crm-index-associations-lib": "static-1.6466",
  "crm-view-components": "static-1.344",
  "react-beautiful-dnd": "static-1.13",
  "tanstack-virtual": "static-1.30",
  "nudge-custom-function-registry": "static-1.2396",
  "nudge-renderer-utils": "static-1.2715",
  "whisper-core-api": "static-1.6693",
  "InboxConnectUtils": "static-4.14885",
  "emoji-regex": "static-1.7",
  "touchless-buying-components": "static-1.5609",
  "settings-content-modals": "static-1.46157",
  "crm_universal": "static-1.22049",
  "customer-data-email": "static-1.18076",
  "card-payment-highlight-lib": "static-1.37251",
  "card-subscription-highlight-lib": "static-1.39616",
  "commerce-contract-lib": "static-1.12178",
  "invoices-highlight-card-lib": "static-1.54810",
  "orders-highlight-card-lib": "static-1.21540",
  "products-highlight-card-lib": "static-1.17941",
  "quotes-highlight-card-lib": "static-1.72135",
  "crm-source-interpretation-lib": "static-1.5369",
  "utility-belt": "static-1.2559",
  "payments-enrollment-embed-lib": "static-1.22973",
  "stripe-embedded-components": "static-1.7548",
  "customer-data-rte": "static-1.33064",
  "cv-backend-services": "static-1.1553",
  "growth-onboarding-empty-states": "static-1.5778",
  "payments-post-enroll-local-storage-lib": "static-1.5134",
  "qrcode-generator": "static-1.69",
  "quotes-client-types": "static-1.38225",
  "trials-service-types": "static-1.3929",
  "calling-orchestration-schema": "static-1.35861",
  "sales-views-client-types": "static-1.4284",
  "hub-http-contrib": "static-1.3067",
  "interframe": "static-3.4785",
  "tinymce-data": "static-1.40526",
  "ui-addon-sales-email": "static-1.5236",
  "layout-dnd-components": "static-1.12492",
  "layout-dnd-utils": "static-1.11467",
  "ui-brand-identity-lib": "static-1.15388",
  "NamespacedHubStyle": "static-2.9077",
  "meetings-connect-utils-lib": "static-1.7630",
  "social-insights-client-types": "static-1.22184",
  "js-cookie": "static-1.18",
  "ably": "static-2.2",
  "crm-index-visualization-core": "static-1.4170",
  "checkout-sdk": "static-3.23711",
  "checkout-service-types": "static-1.3840",
  "company-details-components": "static-1.6221",
  "payment-method-components": "static-1.6927",
  "pricing-pages-ui-components": "static-1.14138",
  "quote-checkout-service-types": "static-1.3493",
  "upgrade-catalog-service-types": "static-1.3545",
  "access-control-lib": "static-1.10461",
  "EmailComponents": "static-1.54821",
  "EmailData": "static-1.53498",
  "redux-less": "static-2.9509",
  "sequences-lib": "static-1.8084",
  "ui-gdpr-components": "static-1.10376",
  "products-ui-components": "static-1.40176",
  "accounting-integrations-ui-components": "static-1.7103",
  "invoices-ui-lib": "static-1.54826",
  "commerce-products-api": "static-1.2333",
  "invoices-iframe-lib": "static-1.56884",
  "quotes-modal-lib": "static-1.102813",
  "quotes-ui-lib": "static-1.80856",
  "stripe-connect-js": "static-1.69",
  "draft-content-plugins": "static-1.28337",
  "ContentData": "static-1.68516",
  "layout-data-lib": "static-1.9792",
  "hub-http-rxjs": "static-1.804",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "company-details-service-types": "static-1.3964",
  "billing-payments-client-types": "static-1.4015",
  "react-performance-metrics-lib": "static-1.581",
  "account-and-billing-fintech-outages": "static-3.18623",
  "pricing-pages-api": "static-1.14003",
  "ContentComponents": "static-2.71397",
  "marketing-contacts-lib": "static-1.10129",
  "marketing-email-service-types": "static-1.1920",
  "messaging-editing-lib": "static-1.46348",
  "messaging-usage-based-billing-components-lib": "static-1.1210",
  "automation-ui-source-apps": "static-1.18963",
  "automation-ui-types": "static-1.19881",
  "messaging-types-lib": "static-1.46085",
  "onboarding-settings-client": "static-1.4530",
  "sequences-client-types-lib": "static-1.7941",
  "commerce-tax-lib": "static-1.552",
  "price-books-api": "static-1.853",
  "price-books-components": "static-1.911",
  "property-description-translator": "static-1.3868",
  "ramp-editor": "static-1.206",
  "commerce-analytics-service-client": "static-1.3655",
  "totals-ui-components": "static-1.23671",
  "SalesContentIndexUI": "static-3.9288",
  "advanced-menus-core": "static-1.15166",
  "advanced-menus-lib": "static-1.12104",
  "ui-memberships-settings-lib": "static-1.34116",
  "segments-query-core": "static-1.1444",
  "demographics-service-types": "static-1.1678",
  "eligibility-engine-service-types": "static-1.3210",
  "automation-ui-ubb": "static-1.5797",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7364",
  "data-token-views": "static-1.16430",
  "forms-utils-lib": "static-1.12630",
  "payments-embed-points-lib": "static-1.13088",
  "simple-menus-core": "static-1.15165",
  "simple-menus-lib": "static-1.16682",
  "videoconference-integration-components": "static-1.6856",
  "marketing-contacts-client": "static-1.7542",
  "automation-applications-service-types": "static-1.3534",
  "automation-platform-service-types": "static-1.2594",
  "ContentEditorUI": "static-2.77191",
  "short-messages-app-service-client": "static-1.3994",
  "web-interactives-components": "static-1.13801",
  "web-interactives-data": "static-1.13802",
  "messaging-shared-utils-lib": "static-1.659",
  "messaging-user-info-utils-lib": "static-1.829",
  "email-portal-health-service-types": "static-1.1003",
  "line-items-api": "static-1.733",
  "commerce-totals-service-types": "static-1.3838",
  "FireAlarmUi": "static-1.4531",
  "sales-templates-service-types-lib": "static-1.4189",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.21817",
  "automation-ui-usage-tracking": "static-1.21280",
  "data-studio-ubb": "static-1.2799",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.27092",
  "collaboration-sidebar": "static-1.57903",
  "content-management-data-lib": "static-1.5422",
  "copilot-plugins": "static-1.11171",
  "cta-picker": "static-1.36473",
  "customer-agent-discovery-components-lib": "static-1.3154",
  "editor-components": "static-1.13263",
  "editor-iframe-lib": "static-1.8437",
  "error-messaging-js": "static-1.5218",
  "FormsCommonComponents": "static-1.85923",
  "pictos": "static-7.184",
  "react-transition-group": "static-2.65",
  "redux-request-state": "static-1.10670",
  "SharedLegalStrings": "static-1.1772",
  "smart-content-core": "static-1.42514",
  "smart-content-lib": "static-1.43167",
  "social-composer-lib": "static-1.59264",
  "structured-content-lib": "static-1.25261",
  "theme-previewer-lib": "static-1.53307",
  "tinymce-copilot": "static-1.16509",
  "xray-recommendation-lib": "static-1.7943",
  "automation-ui-routing": "static-1.21238",
  "sql-reporting-client-types": "static-1.5655",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42253",
  "campaigns-utils-lib": "static-1.3207",
  "reporting-enablement": "static-1.23011",
  "chatspot-widget-iframe": "static-1.21404",
  "collaboration-sidebar-common": "static-1.2700",
  "forms-ai-lib": "static-1.4356",
  "codemirror-dlb": "static-1.58750",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6457",
  "report-customization-components": "static-1.13243",
  "data-quality-ui-library": "static-1.13104",
  "html-to-image": "static-1.54",
  "reporting-filters": "static-1.389",
  "reporting-insights-lib": "static-1.1822"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.12347",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.469",
  "data-fetching-client": "/data-fetching-client/static-1.9692",
  "foundations-components": "/foundations-components/static-1.7985",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1010",
  "foundations-theming": "/foundations-theming/static-1.4445",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.82",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8039",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10024",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyleTokens": "/HubStyleTokens/static-2.11498",
  "I18n": "/I18n/static-7.1631",
  "jasmine-runner": "/jasmine-runner/static-1.6489",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.12408",
  "quartz": "/quartz/static-1.7063",
  "react-dlb": "/react-dlb/static-1.79",
  "react-rhumb": "/react-rhumb/static-1.16697",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2884",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9600",
  "settings-ui-lib": "/settings-ui-lib/static-1.12545",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7184",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11174",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9567",
  "unified-auth": "/unified-auth/static-1.522",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.804",
  "usage-tracker": "/usage-tracker/static-1.7373",
  "usage-tracker-core": "/usage-tracker-core/static-1.7223",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8116",
  "hub-http": "/hub-http/static-1.6247",
  "integrations-lib": "/integrations-lib/static-1.16236",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.19827",
  "property-management-iframe": "/property-management-iframe/static-1.13244",
  "quartz-config": "/quartz-config/static-1.841",
  "quartz-core": "/quartz-core/static-1.6282",
  "quartz-routing": "/quartz-routing/static-1.493",
  "quick-fetch": "/quick-fetch/static-1.3935",
  "react": "/react/static-7.186",
  "rpc-client-utils": "/rpc-client-utils/static-1.4677",
  "ts-schema": "/ts-schema/static-1.4099",
  "ui-universal-auth": "/ui-universal-auth/static-1.9008",
  "UIComponents": "/UIComponents/static-3.8444",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.79",
  "metrics-js": "/metrics-js/static-1.9637",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3418",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3340",
  "quartz-webpack": "/quartz-webpack/static-1.3287",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.141",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4254",
  "floating-ui": "/floating-ui/static-1.56",
  "foundations-assets": "/foundations-assets/static-1.4893",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2161",
  "framer-motion": "/framer-motion/static-1.72",
  "hs-story-utils": "/hs-story-utils/static-1.9449",
  "react-aria": "/react-aria/static-1.66",
  "react-create-root-preference": "/react-create-root-preference/static-1.29",
  "react-select-plus": "/react-select-plus/static-1.105",
  "react-utils": "/react-utils/static-2.5363",
  "react-virtualized": "/react-virtualized/static-2.99",
  "StyleGuideUI": "/StyleGuideUI/static-3.487",
  "tanstack-table": "/tanstack-table/static-1.55",
  "trellis-assets": "/trellis-assets/static-1.2025",
  "ui-fonts": "/ui-fonts/static-1.760",
  "ui-images": "/ui-images/static-2.1160",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2928",
  "foundations-theming-base": "/foundations-theming-base/static-1.3430",
  "stylex": "/stylex/static-1.33",
  "HeadJS": "/HeadJS/static-2.764",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3150",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.152",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.221",
  "moment-timezone": "/moment-timezone/static-5.83",
  "jasmine": "/jasmine/static-4.4352",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9035",
  "ai-rendering-library": "/ai-rendering-library/static-1.10258",
  "chirp-fetch": "/chirp-fetch/static-1.1913",
  "connections-embed-lib": "/connections-embed-lib/static-1.1034",
  "copilot-toolkit": "/copilot-toolkit/static-1.11198",
  "feedback-loader": "/feedback-loader/static-1.29340",
  "laboratory-lib": "/laboratory-lib/static-3.7181",
  "marketplace-embed": "/marketplace-embed/static-1.22158",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.9723",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.19783",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.13998",
  "sanitize-text": "/sanitize-text/static-1.8168",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8728",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5787",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5059",
  "wootric-nps": "/wootric-nps/static-1.6999",
  "quartz-head": "/quartz-head/static-1.728",
  "web-vitals": "/web-vitals/static-1.6",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4677",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4179",
  "highcharts": "/highcharts/static-8.104",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2500",
  "reporting-data": "/reporting-data/static-1.67667",
  "cssUtils": "/cssUtils/static-1.798",
  "flux-actions": "/flux-actions/static-1.341",
  "HubStyle": "/HubStyle/static-2.11805",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10233",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10391",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7363",
  "icons": "/icons/static-2.650",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.18360",
  "storybook-react": "/storybook-react/static-1.33",
  "trellis-story-utils": "/trellis-story-utils/static-1.4540",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5468",
  "quartz-i18n": "/quartz-i18n/static-1.738",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.313",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.444",
  "slack-ui-library": "/slack-ui-library/static-1.10417",
  "fsm": "/fsm/static-1.3757",
  "customer-data-objects": "/customer-data-objects/static-1.7698",
  "property-translator": "/property-translator/static-1.5424",
  "hs-locale-management": "/hs-locale-management/static-1.99",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7952",
  "hs-promise-utils": "/hs-promise-utils/static-1.5616",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4904",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13651",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5627",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7807",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4501",
  "superstore": "/superstore/static-1.4786",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10195",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7923",
  "hub-http-janus": "/hub-http-janus/static-1.838",
  "hubspotter-http": "/hubspotter-http/static-1.4670",
  "immutable-less": "/immutable-less/static-1.4678",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.17234",
  "nav-meta": "/nav-meta/static-1.29747",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10272",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18034",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3865",
  "property-management-common": "/property-management-common/static-1.5532",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9085",
  "dispatcher": "/dispatcher/static-1.137",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.538",
  "module-federation": "/module-federation/static-1.23",
  "quartz-auth": "/quartz-auth/static-1.738",
  "quartz-test": "/quartz-test/static-1.738",
  "quartz-tracking": "/quartz-tracking/static-1.442",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.87",
  "bender-build-tools": "/bender-build-tools/static-1.3215",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.21413",
  "ContentUtils": "/ContentUtils/static-1.68441",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13054",
  "sassPrefix": "/sassPrefix/static-1.156",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.75",
  "avatar-components": "/avatar-components/static-1.2523",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39891",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13191",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.14429",
  "ExportDialog": "/ExportDialog/static-6.10409",
  "highlight.js": "/highlight.js/static-1.79",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.41377",
  "reporting-snowflake": "/reporting-snowflake/static-1.56285",
  "reporting-ui-components": "/reporting-ui-components/static-2.64938",
  "reporting-visualizations": "/reporting-visualizations/static-1.59743",
  "ui-addon-teams": "/ui-addon-teams/static-1.21590",
  "magpie-lib": "/magpie-lib/static-1.5568",
  "navigation-components": "/navigation-components/static-1.18110",
  "magpie-types": "/magpie-types/static-1.5028",
  "simple-logging-lib": "/simple-logging-lib/static-1.3076",
  "ai-studio-lib": "/ai-studio-lib/static-1.11690",
  "app-governance-lib": "/app-governance-lib/static-1.1615",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10536",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8024",
  "ui-product-approvals": "/ui-product-approvals/static-1.28214",
  "ui-tool-access": "/ui-tool-access/static-1.10172",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.9018",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5790",
  "usage-tracker-public": "/usage-tracker-public/static-1.7184",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3605",
  "persist-promise": "/persist-promise/static-1.3724",
  "reference-resolvers": "/reference-resolvers/static-1.8196",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3949",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.363",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3039",
  "final-form": "/final-form/static-1.70",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.2852",
  "merchandise-lib": "/merchandise-lib/static-1.264",
  "atom": "/atom/static-1.5098",
  "purchase-motions-components": "/purchase-motions-components/static-1.5965",
  "salesImages": "/salesImages/static-1.525",
  "batch-promise": "/batch-promise/static-1.1567",
  "crm-component-utils": "/crm-component-utils/static-1.39147",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5910",
  "customer-data-properties": "/customer-data-properties/static-1.51657",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6910",
  "property-value-citations": "/property-value-citations/static-1.2271",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8120",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9080",
  "navigation-messaging": "/navigation-messaging/static-1.7437",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10022",
  "cms-field-types": "/cms-field-types/static-1.4837",
  "content-icons-ui": "/content-icons-ui/static-1.2233",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9851",
  "events-data-lib": "/events-data-lib/static-1.249",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7273",
  "crm-message-bus": "/crm-message-bus/static-1.43040",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22326",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4744",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4024",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6815",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1005",
  "onboarding-tours": "/onboarding-tours/static-1.16660",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13755",
  "academy-common-lib": "/academy-common-lib/static-1.13889",
  "content-assistance-lib": "/content-assistance-lib/static-1.7789",
  "dashboard-lib": "/dashboard-lib/static-1.81633",
  "file-manager-components": "/file-manager-components/static-1.23690",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18521",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18303",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18295",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19875",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8727",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4788",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11070",
  "user-context": "/user-context/static-1.5130",
  "growth-payments-core": "/growth-payments-core/static-1.25451",
  "reporting-plugins": "/reporting-plugins/static-1.10365",
  "reporting-reports": "/reporting-reports/static-1.67345",
  "idb-keyval": "/idb-keyval/static-1.44",
  "reactive-lib": "/reactive-lib/static-1.748",
  "nest": "/nest/static-1.254",
  "codemirror": "/codemirror/static-5.95",
  "react-codemirror": "/react-codemirror/static-1.10651",
  "framework-listing-lib": "/framework-listing-lib/static-2.28779",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.30775",
  "apps-service-types": "/apps-service-types/static-1.3905",
  "oauth-service-types": "/oauth-service-types/static-1.4276",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.109",
  "onboarding-scopes": "/onboarding-scopes/static-1.6486",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4874",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7690",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14969",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3615",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9337",
  "redux-thunk": "/redux-thunk/static-2.43",
  "purchase-motions-api": "/purchase-motions-api/static-1.5968",
  "signup-constants": "/signup-constants/static-1.18889",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8078",
  "card-properties-lib": "/card-properties-lib/static-1.44262",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37193",
  "crm-actions": "/crm-actions/static-1.6352",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.43664",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9351",
  "customer-data-tracking": "/customer-data-tracking/static-1.6915",
  "hs-resources": "/hs-resources/static-1.179",
  "pulse": "/pulse/static-1.602",
  "calling-global-api": "/calling-global-api/static-1.64600",
  "calling-internal-common": "/calling-internal-common/static-1.31327",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65982",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58276",
  "commerce-products-lib": "/commerce-products-lib/static-1.9658",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3816",
  "crm-links": "/crm-links/static-1.6320",
  "external-options-client-types": "/external-options-client-types/static-1.4178",
  "google-libphonenumber": "/google-libphonenumber/static-1.38",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4242",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.657",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3710",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48828",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3984",
  "smart-property-lib": "/smart-property-lib/static-1.7213",
  "tiered-pricing": "/tiered-pricing/static-1.1272",
  "zustand": "/zustand/static-1.74",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11015",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4158",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.29",
  "react-dnd-compat": "/react-dnd-compat/static-1.4640",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.955",
  "growth-data-modal": "/growth-data-modal/static-1.5466",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3092",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1992",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.726",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7576",
  "academy-service-client": "/academy-service-client/static-1.3707",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.39189",
  "FileManagerLib": "/FileManagerLib/static-1.39330",
  "video-embed": "/video-embed/static-1.35852",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28631",
  "redux-actions": "/redux-actions/static-3.7",
  "video-components-external": "/video-components-external/static-1.11360",
  "video-data-lib": "/video-data-lib/static-1.35018",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8497",
  "payment-link-components": "/payment-link-components/static-1.23612",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9913",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24426",
  "viral-links-lib": "/viral-links-lib/static-1.7091",
  "data-token-picker": "/data-token-picker/static-1.16449",
  "react-flip-move": "/react-flip-move/static-1.70",
  "nested-table": "/nested-table/static-1.251",
  "timezone-utils": "/timezone-utils/static-2.5270",
  "seat-types-lib": "/seat-types-lib/static-1.69",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17639",
  "ui-addon-opt": "/ui-addon-opt/static-4.8389",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.9190",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "customer-data-associations": "/customer-data-associations/static-1.7351",
  "customer-data-views-management": "/customer-data-views-management/static-1.25516",
  "framework-data-table": "/framework-data-table/static-2.11972",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.6883",
  "nudge-client-utils": "/nudge-client-utils/static-1.2639",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1062",
  "app-users-service-client": "/app-users-service-client/static-1.5623",
  "app-users-service-types": "/app-users-service-types/static-1.5031",
  "mini-checkout-client": "/mini-checkout-client/static-1.26868",
  "onboarding-utils": "/onboarding-utils/static-1.5379",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2046",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.28616",
  "edison-service-client-types": "/edison-service-client-types/static-1.414",
  "crm_data": "/crm_data/static-4.92043",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46089",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.16331",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4282",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.19158",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18609",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10445",
  "crm-fe-perf": "/crm-fe-perf/static-1.22929",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.105",
  "directed-graph": "/directed-graph/static-1.960",
  "event-emitter": "/event-emitter/static-1.973",
  "fast-json-patch": "/fast-json-patch/static-1.63",
  "calling-error-reporting": "/calling-error-reporting/static-1.31334",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11062",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6566",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1084",
  "commerce-permissions": "/commerce-permissions/static-1.795",
  "products-iframe-lib": "/products-iframe-lib/static-1.8007",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10406",
  "data-agent-kit": "/data-agent-kit/static-1.233",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10107",
  "policy-lib": "/policy-lib/static-1.6802",
  "react-tinymce": "/react-tinymce/static-1.55315",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10170",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54441",
  "tinymce-plugins": "/tinymce-plugins/static-1.57555",
  "tinymce-themes": "/tinymce-themes/static-1.56411",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1995",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2020",
  "user-context-client": "/user-context-client/static-1.4637",
  "audio-components": "/audio-components/static-1.5952",
  "cropperjs": "/cropperjs/static-1.10",
  "FileManagerImages": "/FileManagerImages/static-1.36841",
  "urlinator": "/urlinator/static-1.4562",
  "video-components": "/video-components/static-1.13363",
  "outpost": "/outpost/static-1.4204",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6605",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12406",
  "content-media-compositions": "/content-media-compositions/static-2.16413",
  "media-bridge-lib": "/media-bridge-lib/static-1.18968",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6148",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5107",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3667",
  "draft-convert": "/draft-convert/static-2.73",
  "draft-extend": "/draft-extend/static-3.75",
  "draft-js": "/draft-js/static-5.78",
  "draft-plugins": "/draft-plugins/static-2.21718",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3869",
  "ts-utils-lib": "/ts-utils-lib/static-1.197",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.731",
  "crm-export-dialog": "/crm-export-dialog/static-1.6314",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6466",
  "crm-view-components": "/crm-view-components/static-1.344",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "tanstack-virtual": "/tanstack-virtual/static-1.30",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2396",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2715",
  "whisper-core-api": "/whisper-core-api/static-1.6693",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14885",
  "emoji-regex": "/emoji-regex/static-1.7",
  "touchless-buying-components": "/touchless-buying-components/static-1.5609",
  "settings-content-modals": "/settings-content-modals/static-1.46157",
  "crm_universal": "/crm_universal/static-1.22049",
  "customer-data-email": "/customer-data-email/static-1.18076",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37251",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39616",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.12178",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54810",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21540",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17941",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72135",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5369",
  "utility-belt": "/utility-belt/static-1.2559",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.22973",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7548",
  "customer-data-rte": "/customer-data-rte/static-1.33064",
  "cv-backend-services": "/cv-backend-services/static-1.1553",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5778",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5134",
  "qrcode-generator": "/qrcode-generator/static-1.69",
  "quotes-client-types": "/quotes-client-types/static-1.38225",
  "trials-service-types": "/trials-service-types/static-1.3929",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35861",
  "sales-views-client-types": "/sales-views-client-types/static-1.4284",
  "hub-http-contrib": "/hub-http-contrib/static-1.3067",
  "interframe": "/interframe/static-3.4785",
  "tinymce-data": "/tinymce-data/static-1.40526",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5236",
  "layout-dnd-components": "/layout-dnd-components/static-1.12492",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11467",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15388",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9077",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7630",
  "social-insights-client-types": "/social-insights-client-types/static-1.22184",
  "js-cookie": "/js-cookie/static-1.18",
  "ably": "/ably/static-2.2",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4170",
  "checkout-sdk": "/checkout-sdk/static-3.23711",
  "checkout-service-types": "/checkout-service-types/static-1.3840",
  "company-details-components": "/company-details-components/static-1.6221",
  "payment-method-components": "/payment-method-components/static-1.6927",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.14138",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3493",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3545",
  "access-control-lib": "/access-control-lib/static-1.10461",
  "EmailComponents": "/EmailComponents/static-1.54821",
  "EmailData": "/EmailData/static-1.53498",
  "redux-less": "/redux-less/static-2.9509",
  "sequences-lib": "/sequences-lib/static-1.8084",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10376",
  "products-ui-components": "/products-ui-components/static-1.40176",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7103",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.54826",
  "commerce-products-api": "/commerce-products-api/static-1.2333",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56884",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.102813",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.80856",
  "stripe-connect-js": "/stripe-connect-js/static-1.69",
  "draft-content-plugins": "/draft-content-plugins/static-1.28337",
  "ContentData": "/ContentData/static-1.68516",
  "layout-data-lib": "/layout-data-lib/static-1.9792",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.804",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "company-details-service-types": "/company-details-service-types/static-1.3964",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4015",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.581",
  "account-and-billing-fintech-outages": "/account-and-billing-fintech-outages/static-3.18623",
  "pricing-pages-api": "/pricing-pages-api/static-1.14003",
  "ContentComponents": "/ContentComponents/static-2.71397",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.10129",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.1920",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.46348",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1210",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.18963",
  "automation-ui-types": "/automation-ui-types/static-1.19881",
  "messaging-types-lib": "/messaging-types-lib/static-1.46085",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4530",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7941",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.552",
  "price-books-api": "/price-books-api/static-1.853",
  "price-books-components": "/price-books-components/static-1.911",
  "property-description-translator": "/property-description-translator/static-1.3868",
  "ramp-editor": "/ramp-editor/static-1.206",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3655",
  "totals-ui-components": "/totals-ui-components/static-1.23671",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9288",
  "advanced-menus-core": "/advanced-menus-core/static-1.15166",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12104",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34116",
  "segments-query-core": "/segments-query-core/static-1.1444",
  "demographics-service-types": "/demographics-service-types/static-1.1678",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3210",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.5797",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7364",
  "data-token-views": "/data-token-views/static-1.16430",
  "forms-utils-lib": "/forms-utils-lib/static-1.12630",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13088",
  "simple-menus-core": "/simple-menus-core/static-1.15165",
  "simple-menus-lib": "/simple-menus-lib/static-1.16682",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.6856",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.7542",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3534",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2594",
  "ContentEditorUI": "/ContentEditorUI/static-2.77191",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.3994",
  "web-interactives-components": "/web-interactives-components/static-1.13801",
  "web-interactives-data": "/web-interactives-data/static-1.13802",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.659",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.829",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1003",
  "line-items-api": "/line-items-api/static-1.733",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3838",
  "FireAlarmUi": "/FireAlarmUi/static-1.4531",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4189",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.21817",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21280",
  "data-studio-ubb": "/data-studio-ubb/static-1.2799",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.27092",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.57903",
  "content-management-data-lib": "/content-management-data-lib/static-1.5422",
  "copilot-plugins": "/copilot-plugins/static-1.11171",
  "cta-picker": "/cta-picker/static-1.36473",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.3154",
  "editor-components": "/editor-components/static-1.13263",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8437",
  "error-messaging-js": "/error-messaging-js/static-1.5218",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85923",
  "pictos": "/pictos/static-7.184",
  "react-transition-group": "/react-transition-group/static-2.65",
  "redux-request-state": "/redux-request-state/static-1.10670",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1772",
  "smart-content-core": "/smart-content-core/static-1.42514",
  "smart-content-lib": "/smart-content-lib/static-1.43167",
  "social-composer-lib": "/social-composer-lib/static-1.59264",
  "structured-content-lib": "/structured-content-lib/static-1.25261",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53307",
  "tinymce-copilot": "/tinymce-copilot/static-1.16509",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.7943",
  "automation-ui-routing": "/automation-ui-routing/static-1.21238",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5655",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42253",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3207",
  "reporting-enablement": "/reporting-enablement/static-1.23011",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.21404",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.2700",
  "forms-ai-lib": "/forms-ai-lib/static-1.4356",
  "codemirror-dlb": "/codemirror-dlb/static-1.58750",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6457",
  "report-customization-components": "/report-customization-components/static-1.13243",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.13104",
  "html-to-image": "/html-to-image/static-1.54",
  "reporting-filters": "/reporting-filters/static-1.389",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1822"
}
};
